import React from 'react'
import { Button, Modal } from 'antd'

const semanticUiModalSizeMap = {
  mini: '30vw',
  tiny: '40vw',
  small: '50vw',
  large: '70vw',
  fullscreen: '100vw',
}

const GenericModal = ({
  // eslint-disable-next-line no-unused-vars
  testId = 'generic',
  open,
  size,
  onClose,
  children,
  title,
  extButton = [],
  ...rest
}) => (
  <Modal
    visible={open}
    onOk={onClose}
    onCancel={onClose}
    destroyOnClose
    title={title || ''}
    footer={
      <React.Fragment>
        {extButton}
        <Button type="primary" onClick={onClose}>
          Hide
        </Button>
      </React.Fragment>
    }
    width={semanticUiModalSizeMap[size]}
  >
    {children(rest)}
  </Modal>
)

export default GenericModal
